import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    ctaSubmit: 'Next',
    partnerOptions: {
      accountingFirm: 'An accounting firm',
      lawyer: 'A lawyer',
    },
    title: 'Which service did you use to create your company?',
  },
  fr: {
    ctaSubmit: 'Suivant',
    partnerOptions: {
      accountingFirm: 'Un cabinet d’expertise comptable',
      lawyer: 'Un avocat',
    },
    title:
      'Quel service pour la création de votre société avez-vous utilisé\u00A0?',
  },
} as const);
